import DiscSource from './DiscSource'

/*
countAnswersByDimension
  type = most
  dimension = D
return number
*/
const countAnswersByDimension = (type, dimension, answers) => {
  return DiscSource.personalities.filter(item => {
    return item[type] === dimension && answers[item.term] === type
  }).length
}

/*
getRowByCount
return object
*/
const getRowByCount = (graph, dimension, value) => {
  return DiscSource.results.find(item => {
    return item[0] === graph && item[1] === dimension && item[4].includes(value)
  })
}

/*
getPatternKey
return string
*/
const getPatternKey = (counts, type = 'change') => {
  const key = counts.map(item => item[type]['segment'] ? item[type]['segment'] : '*').join('')
  return DiscSource.categoryScore[key]
}

/*
getPatternInfo
return object
*/
const getPatternInfo = (key) => {
  return DiscSource.patterns.find(item => item.key === key)
}

/*
getCirclePercents
return object
*/
const getCirclePercents = (counts) => {
  const segmentD = counts.find(v => v.dimension === 'D')['change']['percent']
  const segmentI = counts.find(v => v.dimension === 'I')['change']['percent']
  const segmentS = counts.find(v => v.dimension === 'S')['change']['percent']
  const segmentC = counts.find(v => v.dimension === 'C')['change']['percent']

  return [
    segmentD, // D
    (segmentD + segmentI) / 2, // DI/ID
    segmentI, // I
    (segmentI + segmentS) / 2, // IS/SI
    segmentS, // S
    (segmentS + segmentC) / 2, // CS/SC
    segmentC, // C
    (segmentC + segmentD) / 2 // CD/DC
  ]
}

/*
answers
{
  "Complacente": "most",
  "Exigente": "least",
  "Ousado": "most",
  "Entusiasta": "least"
}
*/
const count = (answers) => {
  return [
    'D',
    'I',
    'S',
    'C'
    // '#'
  ].map(dimension => {
    const countMost = countAnswersByDimension('most', dimension, answers)
    const countLeast = countAnswersByDimension('least', dimension, answers)
    const countChange = countMost - countLeast

    // detect row
    const rowMost = getRowByCount(1, dimension, countMost)
    const rowLeast = getRowByCount(2, dimension, countLeast)
    const rowChange = getRowByCount(3, dimension, countChange)

    // set segments
    const segmentMost = rowMost ? rowMost[3] : null
    const segmentLeast = rowLeast ? rowLeast[3] : null
    const segmentChange = rowChange ? rowChange[3] : null

    // set intensity
    const intensityMost = rowMost ? rowMost[2] : null
    const intensityLeast = rowLeast ? rowLeast[2] : null
    const intensityChange = rowChange ? rowChange[2] : null

    // set percents
    const percentMost = intensityMost ? (intensityMost * 100 / 28) : null
    const percentLeast = intensityMost ? (intensityLeast * 100 / 28) : null
    const percentChange = intensityChange ? (intensityChange * 100 / 28) : null

    return {
      dimension: dimension,
      most: {
        count: countMost,
        segment: segmentMost,
        intensity: intensityMost,
        percent: percentMost
      },
      least: {
        count: countLeast,
        segment: segmentLeast,
        intensity: intensityLeast,
        percent: percentLeast
      },
      change: {
        count: countChange,
        segment: segmentChange,
        intensity: intensityChange,
        percent: percentChange
      }
    }
  })
}

/*
{
  "Complacente": "most",
  "Exigente": "least",
  "Diplomático": "most",
  "Ousado": "least",
  "Consciencioso": "most",
  "Dominante": "least"
  ...
}
*/
const get = (answers) => {
  const counts = count(answers)
  const patternKey = getPatternKey(counts)
  const patternInfo = getPatternInfo(patternKey)
  const circlePercents = getCirclePercents(counts)

  return {
    counts: counts,
    changeIntensities: counts.map(v => v.change.intensity),
    patternKey: patternKey,
    patternInfo: patternInfo,
    circlePercents: circlePercents
  }
}

export default {
  get
}



// WEBPACK FOOTER //
// ./src/components/Disc/DiscResult.js